import MobxCheckbox from './MobxCheckbox'

export default MobxCheckbox
